export enum IndexType {
  Slide = 'Slide',
  Page = 'Page'
}
